var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.6665C8.35185 1.6665 6.74068 2.15525 5.37027 3.07092C3.99986 3.9866 2.93176 5.28809 2.30103 6.81081C1.6703 8.33353 1.50527 10.0091 1.82681 11.6256C2.14836 13.2421 2.94203 14.727 4.10747 15.8924C5.27291 17.0578 6.75776 17.8515 8.37427 18.173C9.99078 18.4946 11.6663 18.3296 13.1891 17.6988C14.7118 17.0681 16.0133 16 16.9289 14.6296C17.8446 13.2592 18.3334 11.648 18.3334 9.99984C18.3334 8.90549 18.1178 7.82186 17.699 6.81081C17.2802 5.79976 16.6664 4.8811 15.8926 4.10728C15.1188 3.33346 14.2001 2.71963 13.1891 2.30084C12.178 1.88205 11.0944 1.6665 10 1.6665ZM10 16.6665C8.23191 16.6665 6.53622 15.9641 5.28598 14.7139C4.03574 13.4636 3.33336 11.7679 3.33336 9.99984C3.33152 8.51929 3.82754 7.08113 4.74169 5.9165L14.0834 15.2582C12.9187 16.1723 11.4806 16.6683 10 16.6665ZM15.2584 14.0832L5.91669 4.7415C7.08131 3.82735 8.51948 3.33133 10 3.33317C11.7681 3.33317 13.4638 4.03555 14.7141 5.28579C15.9643 6.53604 16.6667 8.23173 16.6667 9.99984C16.6685 11.4804 16.1725 12.9185 15.2584 14.0832Z",
    fill: "#1E2632"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.aea6c524904a64da9e63575dfb8e7c15.svg";
export { ForwardRef as ReactComponent };